import type { Entity } from '@core/types';
import { PointElementSubtype } from '@elements/types';
import type { iorganizationManagementApiV1 } from '@deepup/internal-apis';
import { OrderNumber } from '@projects/types/orderNumbers';

export type Project = Entity & {
  name: string;
  labelingType?: iorganizationManagementApiV1.LabelingType;
  activityState?: iorganizationManagementApiV1.ActivityState;
  scanCounts: {
    total: number;
    qaToClarify: number;
    waitPlanDataUpdate: number;
    qaToLabel: number;
    qaReady: number;
    qaDone: number;
    qaToRework: number;
  };
  utmZone: number;
  epsgCode: string;
  proj4Projection: string;
  hasPipeDirections: boolean;
  exportTarget: ExportTarget | null;
  metadata: ProjectMetadata[];
  orderNumbers?: OrderNumber[];
  organizationName: string;
};

export enum ExportTarget {
  Telekom = 'TELEKOM',
}

export type ProjectMetadata = {
  id: string;
  name: string;
  subtype: PointElementSubtype;
  smaNumber: string;
  hk?: string;
};
